import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

@Injectable()
export class AuthenticationService {


  constructor(private http: Http) { }

  // Login
  login(username: string, password: string){
    // console.log({ username: username, password: password });
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return this.http.post('/api/auth', JSON.stringify({ username: username, password: password }),
       {headers: headers})
      .map((response: Response) => {
        if(response.json().code == 200 ){
          let user = response.json().user[0];
          // localStorage.setItem('currentUser', JSON.stringify(user.id));
          // console.log(user.id);
          return user;
        } else {
          return null;
        }
      });
  }

  logout() {
    // remove everything from local storage to log out
    localStorage.clear();
  }

}



// WEBPACK FOOTER //
// /home/hihoo/ibilling/attendence/public/src/app/Service/authentication.service.ts